<template>
  <div class="footer-div">
    <p><a href="https://beian.miit.gov.cn" target="_blank"><span class="span-a">备案号：【闽ICP备2022002263号-2】</span></a></p>
    <p>Copyright ©2022-{{toDate}}  www.booleanda.cc All Rights Reserved. </p>
    <p>邮箱：vba2022@163.com </p>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    msg: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      src3: '',
      toDate: '2022'
    }
  },
  created() {
    var now = new Date()
    this.toDate = now.getFullYear()
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.footer-div{
  text-align: center;
  padding-left: 35%;
  padding-top: 15px;
}
a {
  color: white;
  padding: 8px 16px;
  text-decoration: none;
}
</style>
